import { chartDeviceId, timeLabel } from './device-chart-data'
import { pageTextSources } from './page-context-text-model'
import { gaugeDisplayData } from './gauge-data'

const own = (value, key) => Object.prototype.hasOwnProperty.call(value, key)

export function isDeviceValue (node) {
  return !!node && Number(node.dataType) === 2 && !!node.component &&
    !(node.component.prop === 'text' && node.option && pageTextSources.includes(node.option.textSource)) &&
    ['text', 'gauge'].includes(node.component.prop) && node.component.name === node.component.prop
}

export function deviceValueQuery (parameter = {}, context = {}, editing = false) {
  const deviceId = chartDeviceId(parameter, context, editing)
  if (parameter.property === undefined || parameter.property === null || parameter.property === '') throw new Error('请选择设备属性')
  return { deviceId, property: String(parameter.property) }
}

function checkedSample (envelope, query) {
  const payload = envelope && envelope.payload
  if (!payload) return null // 忽略订阅确认等非属性消息。
  const row = payload.value
  if (!row || typeof row !== 'object' || !own(row, 'value')) throw new Error('平台返回的属性值格式不正确')
  if ((row.deviceId && String(row.deviceId) !== query.deviceId) || (row.property && String(row.property) !== query.property)) return null
  if (payload.timestamp === undefined || payload.timestamp === null || !Number.isFinite(Number(payload.timestamp))) throw new Error('平台返回的属性时间不正确')
  return { timestamp: Number(payload.timestamp), envelope, row }
}

export function latestValueSample (body, query) {
  if (body.result === undefined || body.result === null) return null
  const row = body.result
  if (Array.isArray(row) || typeof row !== 'object') throw new Error('平台返回的最新属性格式不正确')
  // 沿用旧文本/仪表盘数据处理输入：value.payload.value.value / formatValue / unit。
  return checkedSample({ payload: { timestamp: row.timestamp, timeString: timeLabel(Number(row.timestamp)), value: row } }, query)
}

export function realtimeValueSample (envelope, query) {
  if (envelope && envelope.success === false) throw new Error(envelope.message || '实时属性订阅失败')
  return checkedSample(envelope, query)
}

function finiteNumber (value) {
  if (value === null || value === undefined || typeof value === 'boolean' ||
      !['string', 'number'].includes(typeof value) || String(value).trim() === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export function deviceValueData (kind, sample, parameter = {}, base = {}, formatter, safePreview = false, option = {}) {
  if (!sample) return null
  const custom = !safePreview && typeof formatter === 'function'
  let data = custom ? formatter(sample.envelope) : null
  if (custom && (!data || typeof data !== 'object' || Array.isArray(data) || !own(data, 'value'))) throw new Error('数据处理应返回包含 value 的对象')
  if (kind === 'text') {
    const value = custom ? data.value : (sample.row.formatValue === undefined || sample.row.formatValue === null ? sample.row.value : sample.row.formatValue)
    if (value === undefined || value === null) return null
    // 原文本使用 Vue 文本插值，保持字符串输出，0 和 false 不是无数据。
    return { ...(custom ? data : {}), value: typeof value === 'object' ? JSON.stringify(value) : String(value) }
  }
  const value = finiteNumber(custom ? data.value : sample.row.value)
  if (value === null) {
    if ((custom ? data.value : sample.row.value) == null) return null
    throw new Error('仪表盘属性必须是有效数值，可通过数据处理转换')
  }
  const range = gaugeDisplayData({ min: 0, max: 100, ...base, ...(custom ? data : {}) }, option)
  const min = finiteNumber(range.min), max = finiteNumber(range.max)
  if (min === null || max === null || min >= max) throw new Error('仪表盘最小值必须小于最大值，请检查数据值配置')
  const unit = custom && own(data, 'unit') ? data.unit : sample.row.unit || parameter.propertyUnit || range.unit || ''
  return { ...range, min, max, value, unit }
}
